const HeaderLanding = () => {
  return (
    <header className="header-landing">
      <div className="header-landing__title">
        <h1>Tune into the world</h1>
        <div className="header-landing__title__logo">
          <picture>
            {/* Mobile */}
            <source
              media="(max-width: 600px)"
              sizes="70px"
              srcSet="
              /assets/logos/logo-lightning--mobile-1x.webp 70w,
              /assets/logos/logo-lightning--mobile-2x.webp 140w,
              /assets/logos/logo-lightning--mobile-3x.webp 210w,
              /assets/logos/logo-lightning--mobile-4x.webp 280w"
            />

            {/* Tablet & Desktop */}
            <source
              media="(min-width: 601px)"
              sizes="140px"
              srcSet="
              /assets/logos/logo-lightning-1x.webp 140w,
              /assets/logos/logo-lightning-2x.webp 280w,
              /assets/logos/logo-lightning-3x.webp 420w,
              /assets/logos/logo-lightning-4x.webp 560w"
            />

            {/* Fallback */}
            <img src="/assets/logos/logo-lightning-1x.webp" alt="Hiko logo" />
          </picture>
        </div>
      </div>

      <h2>
        Hiko is the mobile app for podcasters, streamers, and music lovers.
        Stream live, discover underground sounds, and connect with your
        community—all from your phone. Your content, your frequency—shared with
        the world.
      </h2>
    </header>
  );
};

export default HeaderLanding;
